export default __webpack_public_path__ + "static/media/two.b2a523ad.svg";